import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var BedOutlineSVG = function BedOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M28 14V5a1 1 0 00-2 0v2H6V5a1 1 0 00-2 0v9a2 2 0 00-2 2v11a1 1 0 002 0v-4h24v4a1 1 0 002 0V16a2 2 0 00-2-2zM17 9h9v5h-9zM6 9h9v5H6zm22 12H4v-5h24z"
  }));
};
BedOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(BedOutlineSVG);